import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {useEffect, useRef} from 'react';

type Props = {
    onFocus?: (e: FocusEvent) => void;
};

export function FocusPlugin({onFocus}: Props) {
    const [editor] = useLexicalComposerContext();
    const focusCallbackRef = useRef(onFocus);

    useEffect(() => {
        return editor.registerRootListener((rootElement, prevRootElement) => {
            // add the listener to the current root element
            const listener = focusCallbackRef.current;
            if (listener) {
                rootElement?.addEventListener('focus', listener);
                prevRootElement?.removeEventListener('focus', listener);
            }
        });
    }, [editor]);

    return null;
}
